import React from 'react';
import { LibSwitch } from './switch.style';

const Switch = ({ ...restProps }) => {
  return <LibSwitch {...restProps} />;
};

export default Switch;
export { Switch };
